<template>
<div id="report-style" >
  <a href="javascript:window.print()" class="print-button">Print Report</a>
  <div id="report-to-print" class="d-flex .flex-*-fill flex-column bd-highlight">
    <div id="report-head" class="d-flex flex-column bd-highlight">
      <div class="d-flex flex-row bd-highlight">
        <div id="report-image" alt="logo"></div>
        <div id="report-header" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-2 bd-highlight"><b>PT. UNILEVER OLEOCHEMICAL INDONESIA</b></div>
          <div class="p-2 bd-highlight"><b><i>FORM TINDAKAN KOREKSI DAN TINDAKAN PENCEGAHAN KELUHAN PELANGGAN</i></b></div>
          <div class="p-2 bd-highlight"><b><i>CORRECTIVE AND PREVENTIVE ACTION FORM CUSTOMER COMPLAINT</i></b></div>
        </div>
        <div id="report-sidebar" class="d-flex flex-fill flex-column bd-highlight">
          <div id="sidebar-border" class="p-1 bd-highlight">No Dok<br/>Ref</div>
          <div id="sidebar-border" class="p-1 bd-highlight">No Terbitan<br/>Issue No</div>
          <div id="sidebar-border" class="p-1 bd-highlight">Halaman<br/>Page No</div>
        </div>
        <div id="report-sidebar" class="d-flex flex-fill flex-column bd-highlight">
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>UOI - F- QA - 056</div>
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>01.1</div>
          <div id="sidebar-border" class="p-1 bd-highlight"><br/>1 of 1</div>
        </div>
      </div>
      <div id="report-title" class="d-flex flex-row bd-highlight">
        <div id="report-sidebar5" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1 bd-highlight">No CPAR : {{ cparcc.complaintNo }}<br/>CPAR No</div>
        </div>
        <div id="report-sidebar5" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1 bd-highlight"></div>
        </div>
        <div id="report-sidebar5" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1">Tanggal : {{moment(cparcc.reportedDate).format("DD MMMM YYYY")}}<br/>Date</div>
        </div>
      </div>
    </div>
    
    <div id="borderline"></div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"><b>Permintaan Perbaikan Oleh :<br/>Request improvement by</b></div>
        <!-- <div class="p-1 bd-highlight">{{cparcc.srNumber}}</div> -->
      </div>
      <div class="d-flex flex-row bd-highlight">
        <div id="box-blank"></div>
        <div class="p-1 bd-highlight">Internal<br/>Internal</div>
      </div>
      <div class="d-flex flex-row bd-highlight">
        <div id="box-filled"></div>
        <div class="p-1 bd-highlight">Pelanggan<br/>Customer</div>
      </div>
       <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"></div>
        <div class="p-1 bd-highlight"></div>
      </div>
       <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight"></div>
        <div class="p-1 bd-highlight"></div>
      </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight">Kepada<br/>To</div>
        <div class="p-2 bd-highlight">: {{cparcc.ownerMemberName}}</div>
      </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div class="p-1 bd-highlight">Divisi<br/>Division</div>
        <div class="p-2 bd-highlight">: {{cparcc.ownerMemberDepartment}}</div>
      </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div><b>A. Informasi Permasalahan (APA) / Information of problem (WHAT)</b></div>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="content-container">
        <div id="main-content">
            <div class="d-flex justify-content-between">
                <div id="report-body-content" class="d-flex flex-row bd-highlight">
                    <div class="p-1 bd-highlight">Detail Keluhan / Detail of Complaint :</div>
                </div>
            </div>
            <div id="report-body-content" class="d-flex justify-content-between">
                <div class="d-flex flex-row bd-highlight">
                    <div class="p-1 bd-highlight"><b>Customer : </b>{{cparcc.customerName}}</div>
                </div>
            </div>
            <div id="report-body-content" class="d-flex justify-content-between">
                <div class="d-flex flex-row bd-highlight">
                    <div class="p-1 bd-highlight"><b>Product : </b>{{cparcc.productName}}</div>
                </div>
            </div>
            <div id="report-table" style="height: 300px;">
                <table class="table table-bordered table-sm">
                    <thead>
                    <tr>
                        <th scope="col">Reported By Customer</th>
                        <th scope="col">PO</th>
                        <th scope="col">SO</th>
                        <th scope="col">Batch Number</th>
                        <th scope="col">Qty</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(list, index) in cparcc.customerComplaintDetail" v-bind:key="index">
                        <td>{{moment(cparcc.reportedDate).format("DD MMMM YYYY")}}</td>
                        <td>{{list.po}}</td>
                        <td>{{list.so}}</td>
                        <td>{{list.batch}}</td>
                        <td>{{list.qty}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div id="report-body-content" class="d-flex justify-content-between" style="height: 200px;">
                <div class="d-flex flex-row bd-highlight">
                    <div class="report-body-description"><b>Issue : </b><br/>{{cparcc.description}}</div>
                </div>
            </div>
            <div id="report-body-content" class="d-flex justify-content-between" style="height: 315px;">
              <div class="d-flex flex-row bd-highlight">
                  <div class="p-1 bd-highlight"><b>Akar penyebab / Root Cause : </b><br/>
                    <ul>
                      <li v-for="item in cparcc.correctivePreventiveInternal" :key="item.rootCauseRemark">
                        {{ item.rootCauseRemark }}
                      </li>
                    </ul>
                  </div>
              </div>
            </div>
            <div id="report-body-content" class="d-flex justify-content-between">
                <div class="d-flex flex-row bd-highlight">
                    <div class="p-1 bd-highlight">Apakah kejadian ini sudah pernah terjadi? : <br/>Had this case happened before?</div>
                </div>
                 <div class="d-flex flex-row bd-highlight">
                    <div v-if="!cparcc.happenedBefore" class="p-1 bd-highlight">Tidak<br/>No</div>
                    <div v-if="cparcc.happenedBefore" class="p-1 bd-highlight">Ya<br/>Yes</div>
                </div>
                <div class="d-flex flex-row bd-highlight">
                    <div class="p-1 bd-highlight"></div>
                </div>
            </div>
        </div>
        <div id="sidebar-right">
            <div id="row-bar2">
                <div id="sidebar-right-detail">
                    <div>Dilaporkan oleh / Report by</div>
                    <br/><br/><br/>
                    <div><b>{{cparcc.reportBy}}</b></div>
                    
                </div>
                <div id="borderline"></div>
                <div id="sidebar-right-detail">
                    <div >Diketahui Oleh / Acknowledge by</div>
                </div>
                <div id="sidebar-right-detail2">
                    <div><b>(Quality Manager)</b></div>
                </div>
            </div>
        </div>
    </div>
    <div id="borderline"></div>

    <div style="height: 180px;">
    </div>

    <div id="borderline"></div>
    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div><b>B. Review & Analisa / Review and Analysis</b></div>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" style="text-align: center;">
      <div>Analisa Permasalahan (4M+1E) / Problem Analysis (4M+1E)</div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" style="height: 230px;">
      <div>1. Mesin / Machine<br/>
        <ul>
          <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.rootCauseType === 'Machine'" :key="item.rootCauseRemark">
            <div>{{ item.rootCauseRemark }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" style="height: 230px;">
      <div>2. Manusia / Man<br/>
        <ul>
          <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.rootCauseType === 'Man'" :key="item.rootCauseRemark">
            <div>{{ item.rootCauseRemark }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" style="height: 230px;">
      <div>3. Bahan / Material<br/>
        <ul>
          <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.rootCauseType === 'Material'" :key="item.rootCauseRemark">
            <div>{{ item.rootCauseRemark }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" style="height: 230px;">
      <div>4. Metoda / Method<br/>
        <ul>
          <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.rootCauseType === 'Method'" :key="item.rootCauseRemark">
            <div>{{ item.rootCauseRemark }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" style="height: 230px;">
      <div>5. Lingkungan / Environment<br/>
        <ul>
          <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.rootCauseType === 'Environment'" :key="item.rootCauseRemark">
            <div>{{ item.rootCauseRemark }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div><b>C. Tindakan koreksi dan Tindakan Pencegahan/ Corrective action  and Preventive Action (Bagaimana)</b></div>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" class="d-flex justify-content-between">
        <div id="report-sidebar3" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1 bd-highlight">Kegiatan Koreksi dan Tindakan Koreksi : (Bagaimana)<br/>Correction and Corrective Action (HOW TO DO)</div>
        </div>
        <div id="report-sidebar4" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1">Dilaksanakan Oleh<br/>Executed By</div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1">Selesai tanggal<br/>Finish date</div>
        </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body">
      <div>Note : </div>
      <div>Koreksi adalah tindakan untuk menghilangkan ketidaksesuaian yang ditemukan dan Tindakan Koreksi adalah tindakan untuk menghilangkan penyebab ketidaksesuaian yang ditemukan</div>
      <div>Correction is action to eliminate a detected nonconformity and Correction action is action to eliminatecthe cause of a detected nonconformity.</div>
      <br/>
      <div>Tindakan pencegahan adalah tindakan untuk menghilangkan penyebab ketidaksesuaian yang potensial atau situasi potensial lain yang tidak dikehendaki.</div>
      <div>Preventive action is action to eliminate the cause of a potential nonconformity or other undesirable potential situation</div>
    </div>
    <div id="borderline"></div>

    <div style="height: 180px;">
    </div>

    <div id="borderline"></div>
    <div id="report-body" class="d-flex justify-content-between">
        <!-- <div id="report-sidebar3" class="d-flex flex-fill flex-column bd-highlight">
            <div class="p-1 bd-highlight">Tindakan Koreksi/ Correction Action</div>
            <div class="p-1 bd-highlight">answer here</div>
        </div> -->
        <div id="report-sidebar3" class="d-flex flex-fill flex-column bd-highlight">
            <div id="report-sidebar6" class="row">
                <div class="form-group col-1">
                    <div id="box-blank"></div>
                </div>
                <div class="form-group col-10">
                    <div class="p-1 bd-highlight">Tindakan Koreksi/ Correction Action</div>
                </div>
            </div>
            <div id="report-sidebar6" class="d-flex flex-fill flex-column bd-highlight">
                <div class="p-1 bd-highlight">
                  <ul>
                    <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.actionType === 'Corrective'" :key="item.rootCauseRemark">
                      <div>{{ item.actionRemark }}</div>
                    </li>
                  </ul>
                </div>
            </div> 
        </div> 
        <div id="report-sidebar4" class="d-flex flex-fill flex-column bd-highlight">
          <div id="report-sidebar6" class="row">
            <div class="form-group col-10">
              <div class="p-1 bd-highlight"><br/></div>
            </div>
          </div>
          <div id="report-sidebar17" class="row">
            <div class="p-1 bd-highlight">
              <ul>
                <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.actionType === 'Corrective'" :key="item.rootCauseRemark">
                  <div>{{ item.picName }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div id="report-sidebar6" class="row">
            <div class="form-group col-10">
              <div class="p-1 bd-highlight"><br/></div>
            </div>
          </div>
          <div id="report-sidebar17" class="row">
            <div class="p-1 bd-highlight">
              <ul>
                <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.actionType === 'Corrective'" :key="item.rootCauseRemark">
                  <div>{{moment(item.targetDate).format("DD MMMM YYYY")}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </div>
    <div id="report-body" class="d-flex justify-content-between">
        <!-- <div id="report-sidebar3" class="d-flex flex-fill flex-column bd-highlight">
            <div id="borderline-dotted"></div>
            <div class="p-1 bd-highlight">Tindakan Perbaikan (diisi ketika ada potensi ketidaksesuaian) / Preventive Action</div>
            <div class="p-1 bd-highlight">answer here</div>
        </div> -->
        <div id="report-sidebar3" class="d-flex flex-fill flex-column bd-highlight">
            <div id="borderline-dotted"></div>
            <div id="report-sidebar6" class="row">
                <div class="form-group col-1">
                    <div id="box-blank"></div>
                </div>
                <div class="form-group col-10">
                    <div class="p-1 bd-highlight">Tindakan Perbaikan (diisi ketika ada potensi ketidaksesuaian) / Preventive Action</div>
                </div>
            </div>
            <div id="report-sidebar6" class="d-flex flex-fill flex-column bd-highlight">
                <div class="p-1 bd-highlight"><ul>
                    <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.actionType === 'Preventive'" :key="item.rootCauseRemark">
                      <div>{{ item.actionRemark }}</div>
                    </li>
                  </ul>
                </div>
            </div> 
        </div> 
        <div id="report-sidebar4" class="d-flex flex-fill flex-column bd-highlight">
          <div id="borderline-dotted2"></div>
          <div id="report-sidebar6" class="row">
            <div class="form-group col-10">
              <div class="p-1 bd-highlight"><br/></div>
            </div>
          </div>
          <div id="report-sidebar17" class="row">
            <div class="p-1 bd-highlight">
              <ul>
                <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.actionType === 'Preventive'" :key="item.rootCauseRemark">
                  <div>{{ item.picName }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div id="borderline-dotted2"></div>
          <div id="report-sidebar6" class="row">
            <div class="form-group col-10">
              <div class="p-1 bd-highlight"><br/></div>
            </div>
          </div>
          <div id="report-sidebar17" class="row">
            <div class="p-1 bd-highlight">
              <ul>
                <li v-for="item in cparcc.correctivePreventiveInternal" v-if="item.actionType === 'Preventive'" :key="item.rootCauseRemark">
                  <div>{{moment(item.targetDate).format("DD MMMM YYYY")}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </div>
    <div id="report-body" class="d-flex justify-content-between">
        <div id="report-sidebar3" class="d-flex flex-fill flex-column bd-highlight">
            <div id="borderline-dotted"></div>
        </div>
        <div id="report-sidebar4" class="d-flex flex-fill flex-column bd-highlight">
            <div id="borderline-dotted2"></div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
            <div id="borderline-dotted2"></div>
        </div>
    </div>
    <div id="report-body" class="d-flex justify-content-between">
        <div id="report-sidebar8" class="d-flex flex-fill flex-column bd-highlight">
            <!-- <br/> -->
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
            <!-- <br/> -->
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
            <!-- <br/> -->
        </div>
    </div>
    <div id="report-body" class="d-flex justify-content-between">
        <br/>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
            <div id="report-table2">
                <table class="table table-bordered table-sm">
                    <thead>
                    <tr>
                        <th scope="col">Disetujui Oleh <br/>Approved By ***</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><br/><br/><br/></td>
                    </tr>
                    <tr>
                        <td>{{cparcc.areaOwnerDepartmentName}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div id="report-table2">
                <table class="table table-bordered table-sm">
                    <thead>
                    <tr>
                        <th scope="col">Dikonfirmasi Oleh <br/>Approved By ****</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><br/><br/><br/></td>
                    </tr>
                    <tr>
                        <td>Manufacturing Director</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1"></div>
        </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" class="d-flex justify-content-between">
      <div class="d-flex flex-row bd-highlight">
        <div><b>D. Verifikasi / Verification</b></div>
      </div>
    </div>
    <div id="borderline"></div>

    <div id="report-body" class="d-flex justify-content-between">
        <div id="report-sidebar6" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1">Status hasil verifikasi / Verification Status</div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1"></div>
        </div>
        <div id="report-sidebar6" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1">Tgl Verifikasi / Verification date :</div>
        </div>
        <div id="report-sidebar2" style="align-self: flex-end;" class="d-flex flex-fill flex-column bd-highlight">
            <div v-if="cparcc.verifiedDate" id="borderline-dotted">{{moment(cparcc.verifiedDate).format("DD MMMM YYYY")}}</div>
            <div v-if="!cparcc.verifiedDate" id="borderline-dotted"></div>
        </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
        <div id="report-sidebar6" class="row">
            <div class="form-group col-1">
              <div v-if="cparcc.verifiedStatus" id="box-blank"></div>
              <div v-if="!cparcc.verifiedStatus" id="box-filled"></div>
            </div>
            <div class="form-group col-5">
                <div class="p-1 bd-highlight">Tidak Selesai / Open</div>
            </div>
            <div class="form-group col-1">
              <div v-if="!cparcc.verifiedStatus" id="box-blank"></div>
              <div v-if="cparcc.verifiedStatus" id="box-filled"></div>
            </div>
            <div class="form-group col-5">
                <div class="p-1 bd-highlight">Selesai / Closed</div>
            </div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1"></div>
        </div>
        <div id="report-sidebar6" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1"></div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
            <div class="p-1"></div>
        </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
        <div class="form-group col-1">
            <div class="p-1 bd-highlight">Keterangan<br/>Remark</div>
        </div>
        <div class="form-group col-11" style="align-self: flex-end;">
            <div id="borderline-dotted"></div><br/><div id="borderline-dotted"></div>
        </div>
    </div>

    <div id="report-body" class="d-flex justify-content-between">
        <br/>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
            <div id="report-table3">
                <table class="table table-bordered table-sm">
                    <thead>
                    <tr>
                        <th scope="col">Diverifikasi Oleh <br/>Verified By **</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><br/><br/><br/></td>
                    </tr>
                    <tr>
                        <td>Fri Wardana Nasution</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1"></div>
        </div>
        <div id="report-sidebar2" class="d-flex flex-fill flex-column bd-highlight">
          <div class="p-1"></div>
        </div>
    </div>
    <div id="borderline"></div>

    <div style="text-align: left;">* Coret yang tidak perlu / Strikethrough Unnecessary</div>
    <div style="text-align: left;">** Quality Assistant Manager</div>
    <div style="text-align: left;">*** Head of Department (corresponding process owner)</div>
    <div style="text-align: left;">**** Manufacturing Director</div>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import api from '../../services/api'
import { cparcc } from '../../models/cparcc'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export default {
  components: {
    AppLookupField, AppDatatable, AppDatePicker
  },
  data() {
    return {
      cparcc: {
        ...cparcc
      }
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
      const cparccApi = api('print/cpar-cc')
      this.cparcc = await cparccApi.getWithParams(this.$route.query.id)
    }
  },
  methods: {
    close() {
    //   this.$router.push({ name: 'approvedQuality' })
    },
    async exportToPdf() {
      const input = document.getElementById('report-to-print')
      const canvas = await html2canvas(input, {
        width: 1600,
        height: 2000
      })
      const imgData = canvas.toDataURL('image/png')

      const pdf = new jsPDF('l', 'mm', 'letter')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      const currentTime = Date.now()
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${this.cparcc.complaintNo}.pdf`)
    }
  }
}
</script>